<template>
  <div class="p-12">
    <div class="max-w-5xl mx-auto">
      <div class="space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500 capitalize">
            {{ $te('contacts') ? $t('contacts') : 'contacts' }}
          </h4>
        </div>

        <BaseAdvancedList searchable :loading="loading" :entities="contacts" :meta="meta">
          <template #header>
            <ContactHeaderLine />
          </template>

          <template #default="listProps">
            <ContactLine :contact="listProps.entity" @contact-edit="setContactIdToEdit" />
          </template>
        </BaseAdvancedList>
      </div>

      <portal v-if="contactIdToEdit" to="app-modal">
        <ContactModal :contact-id="contactIdToEdit" @hide="handleCancelEdit" />
      </portal>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import ContactHeaderLine from '@/components/Contacts/ContactHeaderLine.vue';
import ContactLine from '@/components/Contacts/ContactLine.vue';
import ContactModal from '@/components/ContactModal/Index.vue';

export default {
  components: {
    ContactHeaderLine,
    ContactLine,
    ContactModal,
  },
  data: () => ({
    loading: false,
    displayDeleteConfirmation: false,
    contactIdToEdit: null,
    lastEditedContactId: null,
  }),
  computed: {
    ...mapState('ui/contacts', ['meta']),
    ...mapGetters('ui/contacts', ['contacts']),
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...mapActions('ui/contacts', {
      fetchContactList: 'load',
      deleteContact: 'destroy',
    }),
    ...mapMutations('ui/contacts', ['setIds', 'setMeta', 'setLinks']),
    async fetchData() {
      const { query } = this.$route;
      this.loading = true;
      try {
        await this.fetchContactList({
          params: {
            ...query,
            include: 'primaryPhoneNumber,primaryEmailAddress',
          },
        });
      } catch (error) {
        //
      }
      this.loading = false;
    },
    setContactIdToEdit(contactId) {
      this.contactIdToEdit = contactId;
      this.lastEditedContactId = contactId;
    },

    handleCancelEdit() {
      this.fetchData();
      this.contactIdToEdit = null;
    },
  },
};
</script>
